import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-power"
    ,templateUrl: "./icon.power.component.html"
    ,styleUrls: ["./icon.power.component.scss"]
    ,providers: []
})
export class IconPowerComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    itemColor:string = "badge-secondary";
    textTooltip:string = "전원상태";
    @Input() carInfo:any;

    constructor(
        
    ){

    }

    ngOnInit() {
        if(this.carInfo){
            let dtgKeyOnYn = this.carInfo.dtgKeyonYn;
            let textTooltipAppend = "OFF";
            switch(dtgKeyOnYn){
                case "1":
                case "Y":
                case "y":
                    //ON
                    this.itemColor = "badge-success";
                    textTooltipAppend = "ON";
                    break;
                default:
                    //OFF
                    this.itemColor = "badge-secondary";
                    textTooltipAppend = "OFF";
                    break;
            }
            this.textTooltip = `전원상태 (${textTooltipAppend})`;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }
}